<template>
    <div id="UserItemsList">
        <b-container>
            <span v-html="itemsList"></span>
        </b-container>
    </div>
</template>

<script>
import { BContainer } from 'bootstrap-vue';

export default {
  name: 'UserItemsList',
  components: {
    BContainer
  },
  data: function() {
    return {
        userName: '',
        itemsList: ''
    }
  },
  mounted() {
    this.userName = this.$rmEncHyp(this.$route.query.userName);
    this.getList();
  },
  methods: {
    async getList() {
        try {
            const response = await this.$http.get('/getUserItems', {
                params: {
                    userName: this.userName,
                }
            });
            this.itemsList = response.data;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    }
  }
}

</script>

<style>
</style>
